import styled from 'styled-components';
import { GhostButton } from 'ui/button';
import { body2, caption, colors, spacing } from 'ui/theme';

export const TitleText = styled.div`
  ${body2}
  color: ${colors.textPrimary};
`;

export const CaptionText = styled.div`
  ${caption};
  color: ${colors.textSecondary};
`;

export const SingleLineCellWrapper = styled(TitleText)`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap;
  > :nth-child(2) {
    width: 100%;
  }
`;

export const DoubleLineCellWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const NameCellWrapper = styled(TitleText)`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0;
`;

export const ArrowButton = styled(GhostButton)`
  cursor: pointer;
`;

export const ExpandedCell = styled.div`
  margin-top: ${spacing.half};
  grid-column: 1 / span 4;
  grid-row: 2 / span 1;
`;
